import { userConstants } from "../../constants/user.constants";
import { lssetItem, lsgetItem } from "../../helpers/localStorageHelper";

let user = lsgetItem('user');/*  JSON.parse(localStorage.getItem("user")); */
const initialState = user ? { loggedIn: true, user } : {};

export function authentication(state = initialState, action) {
  switch (action.type) {
    case userConstants.LOGIN_REQUEST:
      return {
        loggingIn: true,
        user: action.user
      };
    case userConstants.LOGIN_SUCCESS:
      return {
        loggedIn: true,
        user: action.user
      };
    case userConstants.LOGIN_FAILURE:
      return {
        error: action.error
      };
    case userConstants.LOGOUT:
      return {};
    case userConstants.RESETPASSWORD_REQUEST:
      return { ...state };
    case userConstants.RESETPASSWORD_SUCCESS:
      return { ...state };
    case userConstants.RESETPASSWORD_FAILURE:
      return { ...state, user: action.user };
    case userConstants.SENDRESETPASSWORDTOKEN_REQUEST:
      return { ...state };
    case userConstants.SENDRESETPASSWORDTOKEN_SUCCESS:
      return { ...state };
    case userConstants.SENDRESETPASSWORDTOKEN_FAILURE:
      return { ...state, error: action.error };
    case userConstants.TOGGLE_ADMIN_SUCCESS:
      return { ...state, loggedIn: true, user: action.user };
    case userConstants.UPDATE_SUCCESS:
      let user = lsgetItem("user");

      let newUser = Object.assign({}, user, action.userToken);
      newUser.oid = user.oid;
      lssetItem(newUser, 'user');
  /*     localStorage.setItem("user", JSON.stringify(newUser)); */
      return { ...state, user: newUser };

    case userConstants.SET_DEFAULT_EVENT_SUCCESS:
      return { ...state, user: lsgetItem('user') };
    default:
      return state;
  }
}
